import {
  FORMAT_DATE_DEFAULT,
  FORMAT_DATE_LANGUAGE,
} from '@shared/const/profile.const';

export const convertBase64ToFormData = (dataURI) => {
  const splitDataURI = dataURI.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
  return new Blob([ia], { type: mimeString });
};

export const formatDate = (
  date: Date | number,
  formatDate: Array<any> = FORMAT_DATE_DEFAULT,
  separator = '-'
) => {
  const format = (m) => {
    const f = new Intl.DateTimeFormat(FORMAT_DATE_LANGUAGE, m);
    return f.format(date);
  };
  return formatDate.map(format).join(separator);
};
